import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultipleSelectComponent } from './multiple-select.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [MultipleSelectComponent],
  exports: [MultipleSelectComponent]
})
export class MultipleSelectModule { }
